import { Component, AfterViewInit, ChangeDetectorRef,  ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})

export class PlayerComponent implements AfterViewInit {
  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService,  private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/player/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Code', type: 'string', key: 'code'}, 
          {label: 'Name', type: 'string', key: 'name'}, 
          {label: 'Mobile', type: 'string', key: 'mobile'}, 
          {label: 'DOB', type: 'date', key: 'dob'}, 
          {label: 'Wallet Balance', type: 'price', key: 'wallet'}, 
          {label: 'Status', type: 'status', key: 'status'}, 
          {label: 'Can Login', type: 'status', key: 'can_login'}, 
          {label: 'Remark', type: 'string', key: 'remark'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/player/form', hide: true},
          {label: 'Topup/Withdraw/Transfer', type: 'link-status', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/topup-withdraw/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'player', title: 'name', hide: true},
        ]}
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

  async export() {

    const player = await this.http.post("/admin/export/player");

    let csvData = this.convertToCSV(player, ['id', 'code', 'name', 'mobile', 'can_login', 'referral_code', 'payment_account', 'payment_bank', 'status', 'timestamp']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "player" + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  convertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    for (let index in headerList) {
     row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
     let line = (i+1)+'';
     for (let index in headerList) {
      let head = headerList[index];
      line += ',' + array[i][head];
     }
     str += line + '\r\n';
    }
    return str;
   }
}
